import { render, staticRenderFns } from "./AvailabilityStatus.vue?vue&type=template&id=a63d2140"
import script from "./AvailabilityStatus.vue?vue&type=script&lang=js"
export * from "./AvailabilityStatus.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityStatus.vue?vue&type=style&index=0&id=a63d2140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports